import baseRequest from "../_core/baseRequest";

export default {
    // Zone Management (Bölge Müdürlükleri) Operations
    getZoneManagementList: params => {
        const queryParams = new URLSearchParams();
        if (params?.searchText) queryParams.append("searchText", params.searchText);
        if (params?.skip) queryParams.append("skip", params.skip);
        if (params?.limit) queryParams.append("limit", params.limit);
        if (params?.paginate !== undefined) queryParams.append("paginate", params.paginate);
        if (params?.includeDeleted !== undefined)
            queryParams.append("includeDeleted", params.includeDeleted);

        return baseRequest.get(
            `/operation-organization/zone-managements?${queryParams.toString()}`
        );
    },

    getZoneManagementById: params => {
        const queryParams = new URLSearchParams();
        if (params?.includeDeleted !== undefined)
            queryParams.append("includeDeleted", params.includeDeleted);

        return baseRequest.get(
            `/operation-organization/zone-managements/${params.id}?${queryParams.toString()}`
        );
    },

    createZoneManagement: params => {
        return baseRequest.post("/operation-organization/zone-managements", params);
    },

    updateZoneManagement: params => {
        return baseRequest.put(`/operation-organization/zone-managements/${params.id}`, {
            name: params.name,
            bmUserId: params.bmUserId
        });
    },

    deleteZoneManagement: params => {
        return baseRequest.post(
            `/operation-organization/zone-managements/${params.id}/soft-delete`
        );
    },

    restoreZoneManagement: params => {
        return baseRequest.post(`/operation-organization/zone-managements/${params.id}/restore`);
    },

    // Zone (Bölgeler) Operations
    getZoneList: params => {
        const queryParams = new URLSearchParams();
        if (params?.searchText) queryParams.append("searchText", params.searchText);
        if (params?.zoneManagementId?.length) {
            const zoneManagementIds = Array.isArray(params.zoneManagementId)
                ? params.zoneManagementId
                : [params.zoneManagementId];
            zoneManagementIds.forEach(id => queryParams.append("zoneManagementId", id));
        }
        if (params?.cityId) queryParams.append("cityId", params.cityId);
        if (params?.cityName) queryParams.append("cityName", params.cityName);
        if (params?.skip) queryParams.append("skip", params.skip);
        if (params?.limit) queryParams.append("limit", params.limit);
        if (params?.paginate !== undefined) queryParams.append("paginate", params.paginate);
        if (params?.includeDeleted !== undefined)
            queryParams.append("includeDeleted", params.includeDeleted);

        return baseRequest.get(`/operation-organization/zones?${queryParams.toString()}`);
    },

    getZoneById: params => {
        const queryParams = new URLSearchParams();
        if (params?.includeDeleted !== undefined)
            queryParams.append("includeDeleted", params.includeDeleted);

        return baseRequest.get(
            `/operation-organization/zones/${params.id}?${queryParams.toString()}`
        );
    },

    createZone: params => {
        return baseRequest.post("/operation-organization/zones", {
            name: params.name,
            zoneManagementId: params.zoneManagementId,
            cityId: params.cityId,
            districtIds: params.districtIds,
            syUserIds: params?.syUserIds,
            ikUserIds: params?.ikUserIds,
            agencyUserIds: params?.agencyUserIds,
            agencyIkUserIds: params?.agencyIkUserIds
        });
    },

    updateZone: params => {
        return baseRequest.put(`/operation-organization/zones/${params.id}`, {
            name: params.name,
            zoneManagementId: params.zoneManagementId,
            cityId: params.cityId,
            districtIds: params.districtIds,
            syUserIds: params?.syUserIds,
            ikUserIds: params?.ikUserIds,
            agencyUserIds: params?.agencyUserIds,
            agencyIkUserIds: params?.agencyIkUserIds
        });
    },

    deleteZone: params => {
        return baseRequest.post(`/operation-organization/zones/${params.id}/soft-delete`);
    },

    restoreZone: params => {
        return baseRequest.post(`/operation-organization/zones/${params.id}/restore`);
    },

    getZonesByZoneManagement: params => {
        const queryParams = new URLSearchParams();
        if (params?.includeDeleted !== undefined)
            queryParams.append("includeDeleted", params.includeDeleted);

        return baseRequest.get(
            `/operation-organization/zones/by-zone-management/${
                params.zoneManagementId
            }?${queryParams.toString()}`
        );
    },

    getZonesByCity: params => {
        const queryParams = new URLSearchParams();
        if (params?.includeDeleted !== undefined)
            queryParams.append("includeDeleted", params.includeDeleted);

        return baseRequest.get(
            `/operation-organization/zones/by-city/${params.cityId}?${queryParams.toString()}`
        );
    },

    listZoneSubcompanies: params => {
        return baseRequest.get(`/operation-organization/zones/${params.zoneId}/subcompanies`);
    },

    assignZoneToCourier: params => {
        return baseRequest.post(
            `/operation-organization/zones/${params.zoneId}/assign-to-courier`,
            params
        );
    }
};
